import EventEmitter from 'eventemitter3';
import { AbstractWsConnector, WsMessageBulkAssignmentType } from '@/ws/types';
import { wsDefaultConnector } from '@/ws';
import { WsGroupSubscription } from '@/ws/ws-group-subscription';
import { WsBulkAssignmentMessageContent, BulkAssignmentSubscriptionEvent } from './types';

export class BulkAssignmentNotifier {
  protected readonly eventEmitter = new EventEmitter();

  private readonly group: WsGroupSubscription;

  constructor(protected readonly wsConnector: AbstractWsConnector) {
    this.group = new WsGroupSubscription(
      wsConnector,
      [BulkAssignmentSubscriptionEvent.SubscribeOnBulkOperationNotifications],
      [BulkAssignmentSubscriptionEvent.UnsubscribeFromBulkOperationNotifications],
    );

    this.wsConnector.on((type, content) => {
      if (type !== WsMessageBulkAssignmentType.BulkOperationStatus) {
        return;
      }
      this.eventEmitter.emit(WsMessageBulkAssignmentType.BulkOperationStatus, content);
    });
  }

  on(cb: (data: WsBulkAssignmentMessageContent) => void) {
    this.eventEmitter.on(WsMessageBulkAssignmentType.BulkOperationStatus, cb);
    const releaseGroup = this.group.acquire();

    return () => {
      this.eventEmitter.off(WsMessageBulkAssignmentType.BulkOperationStatus, cb);
      releaseGroup();
    };
  }
}

export const bulkAssignmentNotifier = new BulkAssignmentNotifier(wsDefaultConnector);
